module.exports = __webpack_public_path__ + "img/logo-activo.28801383.svg";